<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="客户信贷"
        class="customer-edit"
        width="1000px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="creditLimit"
          :rules="ruleValidate"
          class="form"
          label-width="130px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户编码" prop="customerOuterNo">
              <el-input v-model="creditLimit.PARTNER" disabled placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="风险类" prop="RISK_CLASS">
              <el-select v-model="creditLimit.RISK_CLASS" filterable placeholder="请选择">
                <el-option
                    v-for="item in constants.RISK_CLASS.$options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户信用组" prop="CREDIT_GROUP">
              <el-select v-model="creditLimit.CREDIT_GROUP" filterable placeholder="请选择">
                <el-option
                    v-for="item in CREDIT_GROUP"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款条件" prop="ZTERMName">
              <el-select v-model="creditLimit.ZTERMName" filterable placeholder="请选择">
                <el-option
                    v-for="item in ZTERMList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.name"
                    @click.native="selectZTERMName(item)"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="信用额度" prop="CREDIT_LIMIT">
              <el-input v-model="creditLimit.CREDIT_LIMIT" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效终止日期" prop="LIMIT_VALID_DATE">
              <el-date-picker
                  v-model="creditLimit.LIMIT_VALID_DATE"
                  align="right"
                  type="date"
                  style="width: 335px"
                  placeholder="选择日期"
                  value-format="yyyyMMdd"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="信用管理冻结">
              <el-checkbox v-model="creditLimit.XBLOCKED"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单额度">
              <el-input v-model="creditLimit.SOL_TXT" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="冻结信用管理的理由">
              <el-select v-model="creditLimit.BLOCK_REASON" :disabled="!creditLimit.XBLOCKED" filterable placeholder="请选择">
                <el-option
                    v-for="item in constants.BLOCK_REASON.$options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constants from "@/util/constants";
  import constant from "@/util/constant";
  export default {
    components: {},
    data() {
      return {
        constants,
        constant,
        CREDIT_GROUP: constant.toSelect(constant.CREDIT_GROUP),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        creditLimit: {
          PARTNER: "",
          RISK_CLASS: "",
          CREDIT_GROUP: "",
          ZTERM: "",
          LIMIT_RULE: "ZSTEP",
          CHECK_RULE: "Z1",
          CREDIT_SGMNT: "Z002",
          CREDIT_LIMIT:"",
          LIMIT_VALID_DATE: "",
          XBLOCKED: false,
          BLOCK_REASON: "",
          SOL_TXT: "",
          ZTERMName:"",
        },
        ZTERMList:[],
        ruleValidate: {
          PARTNER: {required: true, message: "不能为空",trigger: "blur"},
          RISK_CLASS: {required: true, message: "不能为空",trigger: "blur"},
          CREDIT_GROUP: {required: true, message: "不能为空",trigger: "blur"},
          ZTERMName: {required: true, message: "不能为空", trigger: ["blur", "change"]},
          CREDIT_LIMIT: {required: true, message: "不能为空", trigger: "blur"},
          LIMIT_VALID_DATE: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(outerNo) {
        this.creditLimit.PARTNER = outerNo;
        console.log(outerNo);
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        this.$http
          .get("basic", "baseDictionarydetails/payment")
          .then(resp => {
            console.log(resp);
            this.ZTERMList = resp;
          });
      },
      selectZTERMName(item) {
        this.creditLimit.ZTERM = item.no;
        this.creditLimit.ZTERMName = item.name;
      },
      handleSubmit() {
        let IT_IN = [];
        let item = {
          PARTNER: this.creditLimit.PARTNER,
          RISK_CLASS: this.creditLimit.RISK_CLASS,
          CREDIT_GROUP: this.creditLimit.CREDIT_GROUP,
          ZTERM: this.creditLimit.ZTERM,
          LIMIT_RULE: "ZSTEP",
          CHECK_RULE: "Z1",
          CREDIT_SGMNT: "Z002",
          CREDIT_LIMIT: this.creditLimit.CREDIT_LIMIT,
          LIMIT_VALID_DATE: this.creditLimit.LIMIT_VALID_DATE,
          XBLOCKED: this.creditLimit.XBLOCKED?"X":"",
          BLOCK_REASON: this.creditLimit.BLOCK_REASON,
          SOL_TXT: this.creditLimit.SOL_TXT,
        };
        IT_IN.push(item);
        let creditLimit = {
          IT_IN : IT_IN,
        };
        console.log(creditLimit);
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "sap/creditLimit",  creditLimit)
              .then((res) => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                if (res.success === false) {
                  this.$message.error(res.message);
                }else {
                  this.$message.success(res.message);
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
